import { useSelector } from 'react-redux'

export const useGetTelesalesUser = () => {
  return useSelector(state => !!state.auth.user.IdToken['custom:is_telesales'])
}
